import type { SVGProps } from "react";

/**
 * call, phone
 * @category Communication
 */
export default function IconCallFilled(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' aria-hidden {...props}>
      <path
        fill='currentColor'
        d='M5.723 3C4.248 3 2.927 4.206 3.097 5.796c.251 2.36.993 4.662 2.19 6.723a17.1 17.1 0 0 0 6.195 6.195c2.075 1.205 4.348 1.913 6.69 2.172 1.598.177 2.829-1.143 2.829-2.636v-1.753a2.75 2.75 0 0 0-1.974-2.639l-1.682-.495a2.69 2.69 0 0 0-2.702.719c-.377.392-.914.452-1.285.212a12.3 12.3 0 0 1-3.652-3.651c-.24-.372-.18-.908.213-1.285a2.69 2.69 0 0 0 .718-2.702l-.494-1.682A2.75 2.75 0 0 0 7.504 3z'
      />
    </svg>
  );
}
